module.exports = __webpack_public_path__ + "img/fish-hook.cf1bdfd7.svg";